import SvgInset from '@/components/SvgInset';
import { CDN_URL_ICONS } from '@/configs';
import React from 'react';

const IcTokenAirdrop = () => {
  return (
    <SvgInset size={240} svgUrl={`${CDN_URL_ICONS}/ic-tokenAirdrop.svg`} />
  );
};

export default IcTokenAirdrop;
